import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../lib/auth";
import { LogoMark } from "../components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato");
      nav(u?.role === "employee" ? "/portal" : "/app");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      // Se backend richiede verifica email (HTTP 403 con verification_required)
      if (err?.response?.status === 403 && detail?.error === "verification_required") {
        toast.info("Per il primo accesso ti abbiamo inviato un codice via email");
        nav(`/verify-email?email=${encodeURIComponent(detail.email || email)}`);
        return;
      }
      // Azienda disattivata
      if (err?.response?.status === 403 && detail?.error === "company_deactivated") {
        toast.error(detail.message || "Azienda disattivata. Contatta il supporto.");
        return;
      }
      toast.error(typeof detail === "string" ? detail : "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FFFAF5] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="orb orb-orange" style={{width: 500, height: 500, top: -200, left: -100, opacity: 0.25}}/>
      <div className="relative w-full max-w-md card-smart p-8 md:p-10" data-testid="login-card">
        <Link to="/" className="inline-flex mb-8" aria-label="Tool Badge home">
          <LogoMark size={64} pulse/>
        </Link>
        <h1 className="font-display text-3xl mb-2">Bentornato.</h1>
        <p className="text-sm text-[#757575] mb-8">Accedi al tuo spazio HR.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="rounded-xl mt-1 h-11" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password">Password</Label>
              <Link to="/forgot-password" data-testid="forgot-link" className="text-xs text-[#FF7A29] hover:underline">Password dimenticata?</Link>
            </div>
            <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="rounded-xl mt-1 h-11" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full h-12 bg-[#FF7A29] hover:bg-[#E85D00] btn-glow shadow-md shadow-orange-200">
            {loading ? "Accesso…" : "Accedi"}
          </Button>
        </form>
        <p className="text-sm text-[#555] mt-6">Non hai un account? <Link to="/register" className="font-semibold text-[#FF7A29] hover:underline">Registra azienda</Link> · <Link to="/register-employee" className="font-semibold text-[#FF7A29] hover:underline" data-testid="register-employee-link">Sono un dipendente</Link></p>
      </div>
    </div>
  );
}
